import { render, staticRenderFns } from "./settlelist.vue?vue&type=template&id=63de4883"
import script from "./settlelist.vue?vue&type=script&lang=js"
export * from "./settlelist.vue?vue&type=script&lang=js"
import style0 from "./settlelist.vue?vue&type=style&index=0&id=63de4883&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports